import { GET_WALLETS, GET_WALLETS_SUCCESS, GET_WALLETS_ERROR, GET_WALLETS_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetWallets = (state = initialState, action) => {
  switch (action.type) {
    case GET_WALLETS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_WALLETS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_WALLETS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_WALLETS_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetWallets;
